export default "__VITE_ASSET__EEiCyEoT__"